export const LENS_MODEL_OPTIONS = Object.freeze([
  { key: 'answerTool', title: 'Answer Tool', subtitle: 'Luna + web and VTAG grounding' },
  { key: 'sonnet', title: 'Sonnet 4.5', subtitle: 'Best answers' },
  { key: 'haiku', title: 'Haiku 4.5', subtitle: 'Fastest' },
  { key: 'sonnet46', title: 'Sonnet 4.6', subtitle: 'Newer reasoning' },
  { key: 'nova2lite', title: 'Nova 2 Lite', subtitle: 'Fast multimodal' },
  { key: 'gemma4', title: 'Gemma 4 31B', subtitle: 'Open multimodal' },
]);

export function lensModelOptionsForStage(stage) {
  if (stage === 'DEV' || stage === 'BETA') {
    return LENS_MODEL_OPTIONS.filter((option) => option.key === 'answerTool');
  }
  return LENS_MODEL_OPTIONS.filter(
    (option) => option.key !== 'answerTool' && option.key !== 'gemma4',
  );
}
